














































































import Vue from "vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { isPeriodSpecification } from "@/features/home/utils";

export default Vue.extend({
  components: {
    "validation-observer": ValidationObserver,
    "validation-provider": ValidationProvider,
  },
  data() {
    return {
      menuForStartDate: false as boolean,
      menuForEndDate: false as boolean,
    };
  },

  props: {
    periodInput: { type: Number, required: true },
    startDateInput: { type: String, required: true },
    endDateInput: { type: String, required: true },
    latestSelectableDate: { type: String, required: true },
  },

  computed: {
    childStartDateInput: {
      get(this: any) {
        return this.startDateInput;
      },
      set(val) {
        return this.$emit("update:startDateInput", val);
      },
    },
    childEndDateInput: {
      get() {
        return this.endDateInput;
      },
      set(val) {
        return this.$emit("update:endDateInput", val);
      },
    },
  },

  methods: {
    isPeriodSpecification(period: number): boolean {
      return isPeriodSpecification(period);
    },
  },

  watch: {
    childStartDateInput: function () {
      // 「開始日」を変更し開始日が終了日を超えた場合、終了日を開始日と同じ日付に変更
      if (this.startDateInput > this.endDateInput)
        this.childEndDateInput = this.childStartDateInput;
    },
    childEndDateInput: function () {
      // 「終了日」を変更し開始日が終了日を超えた場合、開始日を終了日と同じ日付に変更
      if (this.startDateInput > this.endDateInput)
        this.childStartDateInput = this.childEndDateInput;
    },
  },
});
